module.exports = __webpack_public_path__ + "img/shopee_9thb.ddeb52bc.png";